<template>
  <v-main>
    <v-card
      class="ma-2"
      flat
    >
      <v-card-title>Склады</v-card-title>
      <v-container>
        <v-data-table
          :headers="headers"
          :items="warehouses"
          :items-per-page="50"
          :search="search"
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:top>
            <v-toolbar
              flat
              color="white"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
              <v-spacer />
              <router-link :to="{ name: 'WarehouseCreate' }">
                <v-btn
                  color="primary"
                  dark
                >
                  Добавить
                </v-btn>
              </router-link>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'WarehouseView', params: { id: item.id } }">
                  {{ item.id }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'WarehouseView', params: { id: item.id } }">
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'CompanyView', params: { id: item.company } }">
                  {{ item.company_name }}
                </router-link>
              </td>
              <td>{{ item.city }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </v-main>
</template>

<script>
import account from "@/api/account";

export default {
  name: "WarehouseList",
  data() {
    return {
      search: '',
      loading: false,
      headers: [
        {text: 'ID', value: 'id'},
        {text: 'Название', value: 'name'},
        {text: 'Компания', value: 'company'},
        {text: 'Город', value: 'city'},
      ],
      warehouses: [],
    };
  },
  computed: {
    filteredWarehouses() {
      return this.warehouses.filter(wh => {
        const searchTerm = this.search.toLowerCase();
        return (
          wh.name.toLowerCase().includes(searchTerm) ||
          wh.company_name.toLowerCase().includes(searchTerm) || // исправлено здесь
          wh.city.toLowerCase().includes(searchTerm)
        );
      });
    },
  },
  created() {
    this.fetchWarehouses();
  },
  methods: {
    async fetchWarehouses() {
      this.loading = true;
      try {
        const response = await account.getWarehousesList();
        this.warehouses = response.data;
      } catch (error) {
        console.error('Error fetching companies:', error);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>

</style>
